module.exports = __webpack_public_path__ + "img/newAct.55b1033a.svg";